import { render, staticRenderFns } from "./list-table.vue?vue&type=template&id=c2e17676"
import script from "./list-table.vue?vue&type=script&lang=js"
export * from "./list-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports